import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "admin-video-embed"
}
const _hoisted_2 = {
  key: 0,
  class: "file-info"
}
const _hoisted_3 = {
  key: 0,
  class: "file-too-big"
}
const _hoisted_4 = {
  key: 1,
  class: "file-chunked-hint"
}
const _hoisted_5 = {
  key: 2,
  class: "upload-progress-text"
}
const _hoisted_6 = {
  key: 3,
  class: "upload-warning"
}
const _hoisted_7 = {
  key: 0,
  class: "info-hint"
}
const _hoisted_8 = {
  class: "video-actions",
  slot: "end"
}
const _hoisted_9 = {
  key: 2,
  class: "empty-hint"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "ion-text-wrap"
}
const _hoisted_12 = {
  key: 0,
  class: "file-info"
}
const _hoisted_13 = {
  key: 0,
  class: "file-too-big"
}
const _hoisted_14 = {
  key: 1,
  class: "file-chunked-hint"
}
const _hoisted_15 = {
  key: 2,
  class: "upload-progress-text"
}
const _hoisted_16 = {
  key: 3,
  class: "upload-warning"
}
const _hoisted_17 = {
  key: 0,
  class: "info-hint"
}
const _hoisted_18 = {
  class: "video-actions",
  slot: "end"
}
const _hoisted_19 = {
  key: 2,
  class: "empty-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_ctx.embedMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ion_card, { class: "admin-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_header, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_title, null, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("Загрузить видео", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card_content, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_select, {
                      label: "Подраздел медиатеки",
                      "label-placement": "stacked",
                      modelValue: _ctx.uploadSectionKey,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uploadSectionKey) = $event)),
                      interface: "popover",
                      mode: "ios",
                      placeholder: "Выберите раздел"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationSections, (s) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: s.id || s.folderKey,
                            value: s.folderKey
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(s.name) + " (" + _toDisplayString(s.folderKey) + ")", 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_input, {
                      label: "Название для пользователей",
                      "label-placement": "stacked",
                      modelValue: _ctx.uploadDisplayName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uploadDisplayName) = $event)),
                      placeholder: "Отображаемое название видео"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("input", {
                      type: "file",
                      ref: "fileInput",
                      accept: "video/*",
                      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
                    }, null, 544)
                  ]),
                  _: 1
                }),
                (_ctx.selectedFile)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                      _createTextVNode(" Файл: " + _toDisplayString(_ctx.selectedFile.name) + " (" + _toDisplayString(_ctx.formatBytes(_ctx.selectedFile.size)) + ") ", 1),
                      (_ctx.diskSpace && _ctx.selectedFile.size > _ctx.diskSpace.availableBytes)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " — недостаточно места на сервере "))
                        : (_ctx.selectedFile.size > _ctx.LARGE_FILE_WARN_BYTES)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " — будет загружаться по частям (чанковая загрузка) "))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.uploadInProgress)
                  ? (_openBlock(), _createBlock(_component_ion_progress_bar, {
                      key: 1,
                      value: _ctx.uploadProgressPercent / 100,
                      type: "determinate"
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (_ctx.uploadInProgress)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.uploadProgressPercent) + "%", 1))
                  : _createCommentVNode("", true),
                (_ctx.uploadInProgress)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, "⚠️ Не закрывайте окно до завершения загрузки."))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_button, {
                  expand: "block",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doUpload())),
                  disabled: !_ctx.canUpload || _ctx.uploadInProgress
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.uploadInProgress ? 'Загрузка…' : 'Загрузить на сервер'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_card, { class: "admin-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_header, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Видео раздела «" + _toDisplayString(_ctx.mediaCategoryTitle) + "»", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card_content, null, {
              default: _withCtx(() => [
                (_ctx.hasProcessingVideos)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, "ℹ️ Конвертация видео идёт на сервере. Можно закрыть окно и вернуться позднее — прогресс обновится автоматически."))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_select, {
                      label: "Раздел",
                      "label-placement": "stacked",
                      modelValue: _ctx.filterSectionKey,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterSectionKey) = $event)),
                      interface: "popover",
                      mode: "ios",
                      onIonChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadVideos()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select_option, { value: "" }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode("Все разделы", -1)
                          ]))]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationSections, (s) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: s.id || s.folderKey,
                            value: s.folderKey
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(s.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.videos.length)
                  ? (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (v) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            key: v.id,
                            class: "video-row"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h2", null, _toDisplayString(v.displayName), 1),
                                  _createElementVNode("p", null, _toDisplayString(v.sectionName || v.sectionFolderKey) + " · " + _toDisplayString(_ctx.effectiveStatusLabel(v)) + " · " + _toDisplayString(v.sourceType), 1),
                                  (_ctx.isProcessingWithProgress(v))
                                    ? (_openBlock(), _createBlock(_component_ion_progress_bar, {
                                        key: 0,
                                        value: (_ctx.conversionProgress[Number(v.id)]?.percent ?? 0) / 100,
                                        type: "determinate",
                                        class: "conversion-progress"
                                      }, null, 8, ["value"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_badge, {
                                color: _ctx.statusColor(_ctx.effectiveStatus(v))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.effectiveStatusLabel(v)), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"]),
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_ion_button, {
                                  fill: "clear",
                                  color: "medium",
                                  size: "small",
                                  onClick: ($event: any) => (_ctx.renameVideo(v)),
                                  title: "Переименовать"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "icon-only",
                                      icon: _ctx.pencilOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                (v.status === 'PROCESSING')
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 0,
                                      fill: "clear",
                                      color: "warning",
                                      size: "small",
                                      onClick: ($event: any) => (_ctx.cancelConversion(v))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: _ctx.stopCircleOutline
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (v.status === 'FAILED' || v.status === 'CANCELLED')
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 1,
                                      fill: "clear",
                                      color: "primary",
                                      size: "small",
                                      onClick: ($event: any) => (_ctx.retryConversion(v))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: _ctx.refreshOutline
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (v.status === 'READY' || v.status === 'FAILED' || v.status === 'CANCELLED')
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 2,
                                      fill: "clear",
                                      color: "danger",
                                      size: "small",
                                      onClick: ($event: any) => (_ctx.deleteVideo(v))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: _ctx.trashOutline
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, "Нет видео или загрузка не реализована."))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createBlock(_component_ion_page, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_PageHeaderWithMenu, {
            title: "Загрузка видео",
            scrolled: _ctx.headerScrolled
          }, null, 8, ["scrolled"]),
          _createVNode(_component_ion_content, {
            class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
            fullscreen: true,
            onIonScroll: _ctx.onContentScroll
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card, { class: "admin-card disk-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("Место на сервере", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      (_ctx.diskSpace)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Свободно: " + _toDisplayString(_ctx.formatBytes(_ctx.diskSpace.availableBytes)) + " из " + _toDisplayString(_ctx.formatBytes(_ctx.diskSpace.totalBytes)), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_11, "Загрузка данных о месте…"))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card, { class: "admin-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("Загрузить видео", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select, {
                            label: "Подраздел медиатеки",
                            "label-placement": "stacked",
                            modelValue: _ctx.uploadSectionKey,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.uploadSectionKey) = $event)),
                            interface: "popover",
                            mode: "ios",
                            placeholder: "Выберите раздел"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationSections, (s) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  key: s.id || s.folderKey,
                                  value: s.folderKey
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(s.name) + " (" + _toDisplayString(s.folderKey) + ")", 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_input, {
                            label: "Название для пользователей",
                            "label-placement": "stacked",
                            modelValue: _ctx.uploadDisplayName,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.uploadDisplayName) = $event)),
                            placeholder: "Отображаемое название видео"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "file",
                            ref: "fileInput",
                            accept: "video/*",
                            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
                          }, null, 544)
                        ]),
                        _: 1
                      }),
                      (_ctx.selectedFile)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                            _createTextVNode(" Файл: " + _toDisplayString(_ctx.selectedFile.name) + " (" + _toDisplayString(_ctx.formatBytes(_ctx.selectedFile.size)) + ") ", 1),
                            (_ctx.diskSpace && _ctx.selectedFile.size > _ctx.diskSpace.availableBytes)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " — недостаточно места на сервере "))
                              : (_ctx.selectedFile.size > _ctx.LARGE_FILE_WARN_BYTES)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, " — будет загружаться по частям (чанковая загрузка) "))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.uploadInProgress)
                        ? (_openBlock(), _createBlock(_component_ion_progress_bar, {
                            key: 1,
                            value: _ctx.uploadProgressPercent / 100,
                            type: "determinate"
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      (_ctx.uploadInProgress)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.uploadProgressPercent) + "%", 1))
                        : _createCommentVNode("", true),
                      (_ctx.uploadInProgress)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, "⚠️ Не закрывайте окно до завершения загрузки."))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_button, {
                        expand: "block",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.doUpload())),
                        disabled: !_ctx.canUpload || _ctx.uploadInProgress
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.uploadInProgress ? 'Загрузка…' : 'Загрузить на сервер'), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card, { class: "admin-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Видео раздела «" + _toDisplayString(_ctx.mediaCategoryTitle) + "»", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      (_ctx.hasProcessingVideos)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, "ℹ️ Конвертация видео идёт на сервере. Можно закрыть окно и вернуться позднее — прогресс обновится автоматически."))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select, {
                            label: "Раздел",
                            "label-placement": "stacked",
                            modelValue: _ctx.filterSectionKey,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filterSectionKey) = $event)),
                            interface: "popover",
                            mode: "ios",
                            onIonChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadVideos()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "" }, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                  _createTextVNode("Все разделы", -1)
                                ]))]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationSections, (s) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  key: s.id || s.folderKey,
                                  value: s.folderKey
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(s.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.videos.length)
                        ? (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (v) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  key: v.id,
                                  class: "video-row"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h2", null, _toDisplayString(v.displayName), 1),
                                        _createElementVNode("p", null, _toDisplayString(v.sectionName || v.sectionFolderKey) + " · " + _toDisplayString(_ctx.effectiveStatusLabel(v)) + " · " + _toDisplayString(v.sourceType), 1),
                                        (_ctx.isProcessingWithProgress(v))
                                          ? (_openBlock(), _createBlock(_component_ion_progress_bar, {
                                              key: 0,
                                              value: (_ctx.conversionProgress[Number(v.id)]?.percent ?? 0) / 100,
                                              type: "determinate",
                                              class: "conversion-progress"
                                            }, null, 8, ["value"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_badge, {
                                      color: _ctx.statusColor(_ctx.effectiveStatus(v))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.effectiveStatusLabel(v)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"]),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_component_ion_button, {
                                        fill: "clear",
                                        color: "medium",
                                        size: "small",
                                        onClick: ($event: any) => (_ctx.renameVideo(v)),
                                        title: "Переименовать"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            slot: "icon-only",
                                            icon: _ctx.pencilOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]),
                                      (v.status === 'PROCESSING')
                                        ? (_openBlock(), _createBlock(_component_ion_button, {
                                            key: 0,
                                            fill: "clear",
                                            color: "warning",
                                            size: "small",
                                            onClick: ($event: any) => (_ctx.cancelConversion(v))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                slot: "icon-only",
                                                icon: _ctx.stopCircleOutline
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      (v.status === 'FAILED' || v.status === 'CANCELLED')
                                        ? (_openBlock(), _createBlock(_component_ion_button, {
                                            key: 1,
                                            fill: "clear",
                                            color: "primary",
                                            size: "small",
                                            onClick: ($event: any) => (_ctx.retryConversion(v))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                slot: "icon-only",
                                                icon: _ctx.refreshOutline
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      (v.status === 'READY' || v.status === 'FAILED' || v.status === 'CANCELLED')
                                        ? (_openBlock(), _createBlock(_component_ion_button, {
                                            key: 2,
                                            fill: "clear",
                                            color: "danger",
                                            size: "small",
                                            onClick: ($event: any) => (_ctx.deleteVideo(v))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                slot: "icon-only",
                                                icon: _ctx.trashOutline
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock("p", _hoisted_19, "Нет видео или загрузка не реализована."))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class", "onIonScroll"])
        ]),
        _: 1
      }))
}